module.exports = __webpack_public_path__ + "img/questions.523f6cc3.png";